import { connect } from 'react-redux';
import { assign } from 'lodash';
import BaseForm from '../BaseForm/BaseForm';
import {
  addVehicleType,
  showError,
  clearErrors,
} from '../../redux/actions/vehicleTypes';

class VehicleTypeCreateForm extends BaseForm {
  constructor(props) {
    super(props, {
      onSubmit: addVehicleType,
      name: 'Type',
      action: 'Add',
      type: 'create',
      isTypeForm: true,
    });
  }

  /**
   * Handle form validation
   */
  handleValidate(data, isIndex = (index: number) => true) {
    let result = data;
    if (this.props.model.didInvalidate) {
      this.props.dispatch(clearErrors());
    }
    if (isIndex(0) && BaseForm.validator.isEmpty(data.name)) {
      this.props.dispatch(showError('Please specify a name'));
      return false;
    }
    if (isIndex(1) && BaseForm.validator.isEmpty(data.website_slug)) {
      this.props.dispatch(showError('Please specify a website slug'));
      return false;
    }
    if (isIndex(2) && BaseForm.validator.isEmpty(data.full_name)) {
      this.props.dispatch(showError('Please specify a full name'));
      return false;
    }
    if (isIndex(3) && (!data.image || data.image.length === 0)) {
      this.props.dispatch(showError('Please choose an image'));
      return false;
    }
    if (data.image && data.image.length > 0) {
      const image = data.image[0];
      result = assign({}, data, { image });
      if (isIndex(3) && !BaseForm.validator.contains(image.type, 'image')) {
        this.props.dispatch(showError('Please choose a valid image file'));
        return false;
      }
      if (isIndex(3) && image.size >= 5 * 1024 * 1024) {
        this.props.dispatch(showError('Please choose an image under 5MB'));
        return false;
      }
    }
    if (isIndex(4) && !BaseForm.validator.isFloat(data.one_to_two_days)) {
      this.props.dispatch(showError('Please specify a price for one day'));
      return false;
    }
    if (isIndex(5) && !BaseForm.validator.isFloat(data.three_to_six_days)) {
      this.props.dispatch(
        showError('Please specify a price for three to six days'),
      );
      return false;
    }
    if (isIndex(6) && !BaseForm.validator.isFloat(data.seven_days)) {
      this.props.dispatch(
        showError('Please specify a price for seven days or more'),
      );
      return false;
    }
    return result;
  }

  /**
   * Handle form reset
   */
  handleReset(dispatch, actions) {
    dispatch(actions.change('create.name', ''));
    dispatch(actions.change('create.website_slug', ''));
    dispatch(actions.change('create.full_name', ''));
    dispatch(actions.change('create.image', undefined));
    dispatch(actions.change('create.one_to_two_days', ''));
    dispatch(actions.change('create.three_to_six_days', ''));
    dispatch(actions.change('create.seven_days', ''));
  }
}

const mapStateToProps = ({ vehicleTypes }) => ({
  model: vehicleTypes,
  fields: BaseForm.fields.vehicleTypes.create,
  values: {},
});

export default connect(mapStateToProps)(VehicleTypeCreateForm);
